import { useI18n } from "@/i18n";

export const DecisionCard = ({ optionName, rationale, meta = [], testId = "decision-card" }) => {
  const { t } = useI18n();
  return (
    <section
      data-testid={testId}
      className="rounded-[12px] border border-transparent bg-ax-inverse p-5 text-white shadow dark:border-white/20 dark:bg-ax-surface dark:text-ax-text"
    >
      <p className="caption m-0 text-white/70 dark:text-ax-muted">{t("layer.decision")}</p>
      <h2 className="type-h2 m-0 mt-2 [overflow-wrap:anywhere]" data-testid="decision-card-option">
        {optionName}
      </h2>
      {rationale && (
        <div className="mt-3">
          <p className="caption m-0 text-white/70 dark:text-ax-muted">{t("rationale")}</p>
          <p className="m-0 mt-1 text-base leading-6" data-testid="decision-card-rationale">
            {rationale}
          </p>
        </div>
      )}
      {meta.length > 0 && (
        <dl className="m-0 mt-3 flex flex-col gap-1 font-mono text-[13px] leading-[18px]" data-testid="decision-card-meta">
          {meta.map(([k, v]) => (
            <div key={k} className="flex flex-wrap gap-x-2">
              <dt className="text-white/70 dark:text-ax-muted">{k}</dt>
              <dd className="m-0 [overflow-wrap:anywhere]">{v}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
};
